import React from "react";

const Spinner = ({ message = "Loading..." }) => (
  <div className="fixed inset-0 bg-white bg-opacity-70 backdrop-blur-sm flex flex-col justify-center items-center z-50">

    <div className="w-14 h-14 border-4 border-[#9CC9C6] border-t-transparent rounded-full animate-spin"></div>

    <p className="text-gray-600 text-sm font-medium mt-4 select-none">
      {message}
    </p>
  </div>
);

export default Spinner;